import { clickType } from "@/types/generalTypes";
import React from "react";

function Like({ className, onClick }: clickType) {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="28"
      height="28"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5841 3.26657L11.111 4.23396L11.6379 3.26657C12.0724 2.46878 12.7058 1.80284 13.473 1.33508C14.235 0.87049 15.1026 0.617445 15.9895 0.600241C17.4163 0.668048 18.7618 1.30447 19.7334 2.37532C20.7094 3.45099 21.2282 4.87741 21.1738 6.34319L21.1734 6.35432V6.36545C21.1734 8.22379 20.203 10.2419 18.7211 12.2199C17.2495 14.1842 15.3315 16.0325 13.5651 17.5382L13.5647 17.5385C12.8762 18.1265 12.0073 18.4476 11.111 18.4476C10.2147 18.4476 9.34583 18.1265 8.65734 17.5385L8.65693 17.5382C6.89047 16.0325 4.97252 14.1842 3.5009 12.2199C2.01903 10.2419 1.04864 8.22379 1.04864 6.36545V6.35432L1.04822 6.34319C0.993795 4.87741 1.51263 3.45099 2.4886 2.37532C3.46019 1.30447 4.80573 0.668048 6.23255 0.600241C7.1194 0.617445 7.98704 0.87049 8.74903 1.33508C9.51623 1.80284 10.1496 2.46878 10.5841 3.26657Z"
        stroke="#4A4A4A"
        strokeWidth="1.2"
      />
    </svg>
  );
}

export default Like;
